window.SellsyAdminInternalPaymentForm = {
	choosePlan : function(){

		var currentPlan = $("#ipf_plan").val();
		var nbStaff		= $('#ipf_plan option[value="'+currentPlan+'"]').attr('nbAvailableStaff');
		var addonPrice	= $('#ipf_plan option[value="'+currentPlan+'"]').attr('addonPrice');

		$('#ipf_nbAvailableStaff').val(nbStaff);
		$('#ipf_addonPrice').val(addonPrice);

		if (currentPlan.contains('entreprise_')){
			$('#ipf_nbAvailableStaff, #ipf_addonPrice').removeAttr('readonly');
		} else {
			$('#ipf_nbAvailableStaff, #ipf_addonPrice').attr('readonly', 'readonly');
		}

	},

	chooseRqType: function(){

		var corpid = $('#ipf_thirdCorpid').val();
		var rqtype = $('#ipf_rqtype').val();
		var linkeddoc = $('#ipf_linkeddoc').tokenInput("get");

		if (linkeddoc.length > 0){
			linkeddoc = linkeddoc[0].id;
			MyFacture.post('sellsyadmin_internalpayment', {corpid : corpid, rqtype: rqtype, action: 'chooserqtype', linkeddoc: linkeddoc}, function(data){

				$('#paymentOptions').html(data.paymentOptionHtml);
				MyFacture.customForm();
				Qtip.init();

				var newButtons = [
                    {
                        text	: Loc.g("Annuler"),
                        'class'	: 'btn btn-default',
                        click	: function(){ MyWindow.close(); }
                    }, {
						text 	: Loc.g("Provisionner"),
						'class' : 'btn btn-primary',
						click 	: function(){ $('#internalPaymentForm').submit(); }
					}
				];

				MyWindow.addOption('buttons', newButtons);

			}, "json");
		} else {
			MyWindow.alert(Loc.g('Vous devez choisir une facture et un type de requête'), {type:'error'});
		}


	},

	initForm: function(corpid){

		var formID	= 'internalPaymentForm';

		var opts	= {
			title	: Loc.g('Provisionner le compte'),
			width	: 1200,
			height	: 800,
			buttons : [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}
			],
			callback : function(){

				MyFacture.customForm();

				var formOpts = {
					data		: {action : 'recordInternalPaymentForm'},
					dataType	: 'json',
					success		: function(data){
						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							MyWindow.close();
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_internalpayment', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_internalpayment', {action : 'initForm', corpid : corpid}, opts);

	},

	checkUpdateNewEngagement : function(el){

		if($(el).find('option:selected').attr('data-nbMonths') != $('#currentPackage_nbMonths').val()){
			$('#newEngagement').attr('checked', true).bind('click', function(){
				$(this).attr('checked', true);
			});
		}else{
			$('#newEngagement').unbind('click').removeAttr('checked');
		}
	}

};

window.SellsyAdmin = {

	chooseStaff : function(elt){
		var selected = $(elt).multipleSelect('getSelects');
	},

	loadTab : function(action, tabname, corpid){
		$.ajax({
			type		: 'POST',
			url			: '/?_f=sellsyadmin_thirdaddon',
			dataType	: 'json',
			data		: {action : action, corpid : corpid},
			beforeSend	: function(){

			},
			success		: function(data){
				$('#content_'+tabname).html(data.tabContent).show();
				Qtip.init();
			}
		});
	},

	loadProvisionTab : function(tabname, corpid){

		var prefilter = {corpid : corpid};

		$.ajax({
			type		: 'POST',
			url			: '/?_f=tabs',
			dataType	: 'json',
			data		: {
				action		: 'loadListingTab',
				listing		: 'provision',
				corpid		: corpid,
				context		: 'third',
				prefilter	: JSON.stringify(prefilter)
			},
			beforeSend	: function(){

			},
			success		: function(data){

				if (data.listing !== undefined){

					$('#content_'+tabname).html(data.listing).show();
					Listing.init(data.prefix);

					var options = {
						data : {
							action		: 'updateListingTab',
							listing		: 'provision',
							context		: 'third',
							prefilter	: JSON.stringify(prefilter)
						},
						success: function (data) {
							Listing.refresh(data.listingName, data, data[data.metadatasName]);
						},
						dataType: "json"
					};

					MyForm.prepare(data.listingname + "FilterForm", "tabs", options);
					MyFacture.customForm('#content_'+tabname);
					Qtip.init();
				}
			}
		});
	},

	entittyTips : function(){

		var link	= [ 'left','right','top','bottom' ];
		var pos		= [ 'leftMiddle','rightMiddle','topMiddle','bottomMiddle' ];
		var curs	= [ 'rightMiddle','leftMiddle','bottomMiddle','topMiddle' ];

		$(".totip").each(function() {

			var index = 0;
			var $this = $(this);

			var search = $this.attr('positiontips') ? $this.attr('positiontips') : 'right';

			for(var i=0; i<link.length; i++){

	            if(link[i]==search){
	                index = i;
	            }

	        }

			if($this.data("qtip")) $this.qtip("destroy");
			$this.qtip({
				style : {
					classes : 'custom-qtip',
					def		: false
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout',
					fixed: true,
					delay: 100
				},
				content:{
					text : $('#tip-'+$this.attr('id'))
				}
			});
		});
	},

	initConnectionForm : function(){

		var options = {
			data	: {
				action : 'staffConnection'
			},
			dataType	: 'json',
			success		: function(data){
				var win = window.open(data.url, '_blank');
				win.focus();
			}
		};

		MyForm.prepare('staffConnection', 'sellsyadmin_thirdaddon', options);
	},

	corpConnection : function(mode, selectedValue){

		var formId = '#staffConnection';
		var selected = $('select[name="hash"] option:selected', formId);

		if(selected.val() === '' && selectedValue === ''){
			var opt = {
				title: Loc.g('Impossible de se connecter'),
				type: 'error',
				buttons: [
					{
						text	: Loc.g("Ok"),
						click 	: function(){ $(this).dialog("close"); }
					}
				]};

			MyWindow.alert(Loc.g("Impossible de se connecter via SellsyAdmin sur le compte du collaborateur sélectionné. " +
				"<br/><br/>Se rapprocher du support pour plus d'informations."), opt);
		} else {
			$('input[name=mode]', formId).val(mode);
			$(formId).submit();
		}

	},

	createThird : function(corpid, relationType) {
		var formID	= 'thirdFormCreate';

		var opts	= {
			title	: Loc.g('Créer un client / prospect'),
			width	: 1200,
			height	: 800,
			buttons : [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Enregistrer'),
					click	: function(){ $('#'+formID).submit(); }
				}
			],
			callback : function(){

				var formOpts = {
					data		: {action : 'recordThird'},
					dataType	: 'json',
					success		: function(data){
						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							if(data.thirdid !== undefined){
								MyFacture.relocate("third&thirdid=" + data.thirdid);
							} else {
								MyWindow.close();
								Listing.update('corporationListing');
							}
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'createThirdForm', corpid : corpid, relationType : relationType}, opts);
	},

	linkCorporation : function(thirdid){

		var formID	= 'thirdLinkForm';

		var opts	= {
			title		: Loc.g('Lier le client / prospect à un compte Sellsy'),
			width		: 600,
			buttons		: [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Lier'),
					click	: function(){ $('#'+formID).submit(); }
				}
			],
			callback	: function(){

				var formOpts = {
					data		: {action : 'recordLinkThird'},
					dataType	: 'json',
					success		: function(data){
						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);

				var more = {
					'payCurrencyId'	: $('#'+formID).find('#easybillcurrencyid').val(),
					'linked'		: 'none',
					'context'		: 'linkThird',
				};

				checkLinkable = function(item){
					if(item.linkable == false){
						$('#corpid').tokenInput('clear');
						MyWindow.alert('La corp choisie est déjà liée à un third', {type:'error'});
						return false;
					}
				}

				Corporation.autoCorporation('#corpid', 1, more, checkLinkable);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'linkThirdForm', thirdid : thirdid}, opts);
	},

	createCorporation : function(thirdid){

		var formID	= 'registerFromThirdForm';

		var opts	= {
			title	: Loc.g('Créer un compte Sellsy'),
			width	: 1200,
			buttons	: [
				{
					text 	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Créer'),
					click 	: function(){ $('#'+formID).submit(); }
				}
			],
			callback: function(){

				var formOpts = {
					data		: {action : 'recordRegisterFromThird', thirdid : thirdid},
					dataType	: 'json',
					success		: function(data){

						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'registerFromThirdForm', thirdid : thirdid}, opts);

	},

	/**
     * @param {int} corpid
     */
	unlinkCorp : function(corpid){

		var opts = {
			title   : Loc.g('Suppression compte Sellsy'),
			type	: 'warning',
			buttons : [
                {
					text 	: Loc.g("Non"),
					click 	: function(){ $(this).dialog('close'); }
                }, {
					text 	: Loc.g("Oui"),
					click 	: function(){

						MyFacture.post('sellsyadmin_corporation', {
                            corpid : corpid,
                            action : 'unlinkCorpAndThird'
                        }, function(){

                            Utils.reload();
							MyWindow.close('alertWindow');

						}, 'json');
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Délier le compte Sellsy ?'), opts);
	},

	synchronize : function(thirdid, data){

		var allowedDataToSync = ['addresses','staffs'];

		if(data == undefined){
			data = allowedDataToSync;
		} else if(typeof data == 'string'){
			data = [data];
		}

		$.ajax({
			url 	: '/?_f=sellsyadmin_corporation',
			type 	: 'POST',
			data 	: {
				action	: 'synchronize',
				sync 	: data,
				thirdid	: thirdid
			},
			dataType: 'json',
			beforeSend : function(){MyFacture.startWait();},
			success : function(data){

				if(typeof data !== 'object'){
					Push.error(Loc.g('Problème lors de la synchronisation'));
					Utils.reload();
				}

				$.each(data, function(val,status){
					switch(status){
						case 'error' :
							switch (val){
								case 'staffs':
									Push.warning(Loc.g('Aucun collaborateur trouvé sur le compte'));
									break;
								case 'addresses':
									Push.warning(Loc.g('Aucune adresse trouvée sur le compte'));
									break;
								default:
									Push.warning(Loc.g('Aucune donnée à synchroniser trouvée sur le compte'));
									Utils.reload();
									break;
							}
							break;
						case 'success' :
							switch (val){
								case 'staffs':
									Push.success(Loc.g('Synchronisation des contacts effectuée'));
									break;
								case 'addresses':
									Push.success(Loc.g('Synchronisation des adresses effectuée'));
									break;
								default:
									Push.success(Loc.g('Synchronisation effectuée'));
									break;
							}
							Utils.reload();
							break;
					}
				});

				MyFacture.stopWait();
			}
		});


	},

    synchronizeContacts: function (thirdid, corpid) {
        SellsyJS.WebServiceCaller.post(
            '/rest/corporation/' + corpid + '/contacts/synchronize',
            { thirdid: thirdid },
            {},
            () => Push.success(Loc.g('Synchronisation demandée, elle sera effectuée en arrière-plan'), Loc.g('Synchronisation des contacts')),
            () => Push.error(Loc.g('Échec de la synchronisation'), Loc.g('Synchronisation des contacts'))
        );
    },

	staffEnableAsDecisionMaker: function(corpid, staffid) {
		$.ajax({
			url: `/rest/sellsyadmin/${corpid}/decision-maker/${staffid}`,
			type: 'POST',
			dataType: 'json',
			async: false,
			success: function () {
				Utils.reload();
			}
		});
	},
	staffDisableAsDecisionMaker: (corpid, staffid) => {
		$.ajax({
			url: `/rest/sellsyadmin/${corpid}/decision-maker/${staffid}`,
			type: 'DELETE',
			dataType: 'json',
			async: false,
			success: function () {
				Utils.reload();
			}
		});
	},

	updateStaffStatus : function(corpid, staffid, status){
		var opts = {
			title   : Loc.g('Modification statut Staff'),
			type	: 'warning',
			buttons : [
				{
					text 	: Loc.g("Non"),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g("Oui"),
					click 	: function(){

						MyFacture.post('sellsyadmin_corporation', {staffid : staffid, corpid : corpid, newStatus : status, action : 'updateStaffStatus'}, function(data){

							if(data.status == 'ok'){
								MyWindow.close('alertWindow');
								Utils.reload();
							} else {
								MyWindow.error();
							}

						}, 'json');

					}
				}
			]
		};

		var msg;

		if(status == 'blocked'){
			msg = Loc.g('Bloquer le Staff ? ');
		}else if(status == 'ok'){
			msg = Loc.g('Débloquer le Staff ? ');
		}

		MyWindow.alert(msg, opts);
	},

	updateStaffType : function(staffid, corpid, newType){
		var opts = {
			title   : Loc.g('Modification du type de staff'),
			type	: 'warning',
			buttons : [
				{
					text	: Loc.g("Non"),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g("Oui"),
					click 	: function(){

						MyFacture.post('sellsyadmin_corporation', {staffid : staffid, corpid: corpid, newType : newType, action : 'updateStaffType'}, function(data){

							if(data.status == 'ok'){
								MyWindow.close('alertWindow');
								Utils.reload();
							} else {
								MyWindow.error();
							}

						}, 'json');

					}
				}
			]
		};

		var msg;

		msg = Loc.g('Changer le type de staff pour') + " : " + newType + " ?";

		MyWindow.alert(msg, opts);
	},


	editPluginQuota : function(corpid, quotaId){

		var formID	= 'pluginQuotaForm';

		var opts	= {
			title		: Loc.g('Modifier les crédits'),
			width		: 600,
			buttons		: [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Enregistrer'),
					click	: function(){ $('#'+formID).submit(); }
				}
			],
			callback	: function(){

				var formOpts = {
					data		: {action : 'recordPluginQuotaForm', corpid : corpid, quotaId : quotaId},
					dataType	: 'json',
					success		: function(data){
						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							MyWindow.close();
                            SellsyAdmin.loadTab('loadAccountTab','sa_account', corpid);
                            window.sellsyapp.$events.trigger('overviewv2:tablistingv1:refresh');
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'pluginQuotaForm', corpid : corpid, quotaId : quotaId}, opts);

	},


	addLicence: function(corpid, prodid){

		var formID	= 'pluginLicenceForm';

		var opts	= {
			title		: Loc.g('Ajouter une licence trial'),
			width		: 600,
			buttons		: [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Enregistrer'),
					click	: function(){ $('#'+formID).submit(); }
				}
			],
			callback	: function(){

				var formOpts = {
					data		: {action : 'recordPluginLicenceForm', corpid : corpid, prodid : prodid},
					dataType	: 'json',
					success		: function(data){
						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							MyWindow.close();
							SellsyAdmin.loadTab('loadAccountTab','sa_account', corpid);
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'pluginLicenceForm', corpid : corpid, prodid : prodid}, opts);

	},

	deleteLicence: function(corpid, licenceid){

		var opts = {
			title   : Loc.g('Supprimer la licence'),
			type	: 'warning',
			buttons : [
				{
					text 	: Loc.g("Non"),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g("Oui"),
					click 	: function(){

						MyFacture.post('sellsyadmin_corporation', {licenceid : licenceid, corpid: corpid, action : 'deleteLicence'}, function(data){

							if(data.status == 'ok'){
								MyWindow.close('alertWindow');
								SellsyAdmin.loadTab('loadAccountTab','sa_account', corpid);
							} else {
								MyWindow.error();
							}

						}, 'json');

					}
				}
			]
		};

		var msg;

		msg = Loc.g('Supprimer la licence ?');

		MyWindow.alert(msg, opts);

	},

	togglePlugin : function(action, corpid, pluginName, productid, isFree) {

		isFree = isFree !== undefined && isFree;

		var post = function(){
			MyFacture.post('sellsyadmin_corporation', {
				corpid		: corpid,
				pluginName	: pluginName,
				productid	: productid,
				action		: action == 'enable'
					? 'activatePlugin'
					: 'deactivatePlugin'
			}, function(data){

				MyFacture.stopWait();

				if(data.status == 'ok'){
					MyWindow.close('alertWindow');
                    SellsyAdmin.loadTab('loadAccountTab','sa_account', corpid);
                    window.sellsyapp.$events.trigger('overviewv2:tablistingv1:refresh');
				} else {
					MyWindow.error();
				}

			}, 'json');
		};

		if(isFree){

			MyFacture.startWait();
			post();

		} else {

			/** If plugin is not free, then display confirm popup */
			var opts = {
				title   : action == 'enable'
					? Loc.g('Activer un module')
					: Loc.g('Désactiver un module'),
				type	: 'warning',
				buttons : [
					{
						text 	: Loc.g("Non"),
						click 	: function(){ $(this).dialog('close'); }
					}, {
						text 	: Loc.g("Oui"),
						click 	: function(){

							post();

						}
					}
				]
			};

			MyWindow.alert(
				action == 'enable'
					? Loc.g('Voulez-vous vraiment activer le module dans le compte Sellsy du client ?')
					: Loc.g('Voulez-vous vraiment désactiver le module dans le compte Sellsy du client ?'),
				opts);
		}

	},

	addPluginTrial : function(corpid, label, productid){
		var formID	= 'pluginTrialForm';

		var opts	= {
			title		: Loc.g('Modifier le trial du module'),
			width		: 600,
			buttons		: [
				{
					html	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}, {
                    html	: Loc.g('Enregistrer'),
                    click	: function(){ $('#'+formID).submit(); }
                }
            ],
			callback	: function(){

				var formOpts = {
					data		: {action : 'recordPluginTrial', corpid : corpid, productid : productid},
					dataType	: 'json',
					success		: function(data){
						var formOk = MyForm.processJson(data, formID);

						if(data.form.fields.length){
							return;
						}

						MyWindow.close();
						switch (data.form.status){
							case 'ok':
								Push.success(
									(
										data.isTrialEnabled ?
										Loc.g('Trial ajouté sur le plugin') :
										Loc.g('Trial désactivé sur le plugin')
									)
                                );
                                window.sellsyapp.$events.trigger('overviewv2:tablistingv1:refresh');
								break;
							default:
								Push.error(Loc.g(data.form.msg), Loc.g('Erreur'));
								break;
						}

						SellsyAdmin.loadTab('loadAccountTab','sa_account', corpid);


					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'pluginTrialForm', corpid : corpid, productid : productid}, opts);
	},

	linkThirdPayer : function(thirdID){

		var formID	= "thirdPayerForm";
		var opts	= {
			title	: Loc.g('Liaison à un tiers payeur'),
			width	: 600,
			buttons : [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ MyWindow.close(); }
				}, {
                    text	: Loc.g('Lier'),
                    click	: function(){ $('#'+formID).submit(); }
                }
            ],
			callback : function(){

				var formOpts = {
					data: {
						action: 'recordThirdPayer',
						thirdid: thirdID
					},
					dataType: 'json',
					success: function (data) {
						var formOk = MyForm.processJson(data, formID);

						if (formOk) {
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
				MyFacture.customForm('#'+formID);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'thirdPayerForm', thirdid : thirdID}, opts);
	},

	unlinkThirdPayer : function(thirdID){
		var opts = {
			title   : Loc.g('Délier le tiers payeur'),
			type	: 'warning',
			buttons : [
				{
					text 	: Loc.g("Non"),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g("Oui"),
					click 	: function(){

						MyFacture.post('sellsyadmin_corporation', {action : 'unlinkThirdPayer', thirdid : thirdID}, function(data){

							if(data.status == 'ok'){
								Utils.reload();
							} else {
								MyWindow.error();
							}

						}, 'json');

					}
				}
			]
		};

		MyWindow.alert(Loc.g('Voulez-vous vraiment Délier le tiers payeur de ce client ?'), opts);

	},

	toggleTrialBanner: function(corpid, thirdid, display) {
		const opts = {
			title: display ? Loc.g('Cacher la bannière trial') : Loc.g('Afficher la bannière trial'),
			type: 'warning',
			buttons: [
				{
					text: Loc.g('Annuler'),
					click: function () {
						$(this).dialog('close');
					}
				},
				{
					text: display ? Loc.g('Cacher la bannière') : Loc.g('Afficher la bannière'),
					click: function () {
						SellsyJS.WebServiceCaller.post(
							`/rest/corporation/${corpid}/banner/trial`,
							{thirdid: thirdid},
							{},
							function(data) {
								MyWindow.close('alertWindow');
								if (data.message) {
									Push.success(data.message);
								}
							},
							function(error) {
								MyWindow.error();
							}
						);
					}
				}
			]
		};

		const confirm = display
			? Loc.g('Voulez-vous cacher la bannière trial de ce client ?')
			: Loc.g('Voulez-vous afficher la bannière trial de ce client ?');
		MyWindow.alert(confirm, opts);
	},
};


window.Corporation = {

	toggleBlocked: function(thirdid, corpid, blocked){

		var title	= Loc.g('Bloquer le compte');
		var text	= Loc.g('Voulez-vous vraiment bloquer le compte Sellsy du client ?');

		if (blocked == 'N'){
			title	= Loc.g('Débloquer le compte');
			text	= Loc.g('Voulez-vous vraiment débloquer le compte Sellsy du client ?')
		}

		var opts = {
			title   : title,
			type	: 'warning',
			buttons : [
                {
					text 	: Loc.g("Non"),
					click 	: function(){ $(this).dialog('close'); }
                }, {
					text 	: Loc.g("Oui"),
					click 	: function(){

						MyFacture.post('sellsyadmin_corporation', {corpid : corpid, thirdid : thirdid, blocked : blocked, action : 'toggleBlocked'}, function(data){

							if(data.status == 'ok'){
								Utils.reload();
							} else {
								MyWindow.error();
							}

						}, 'json');

					}
				}
			]
		};

		MyWindow.alert(text, opts);

	},

	churn: function(thirdid, corpid){

		var formID	= 'churnForm';

		var opts	= {
			title	: Loc.g('Faire churner le compte'),
			buttons	: [
				{
					text 	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
                    text 	: Loc.g('Enregistrer'),
					click: function(){ $('#'+formID).submit(); }
                }
			],
			callback: function(){

				var formOpts = {
					data		: {action : 'churn', thirdid : thirdid, corpid : corpid},
					dataType	: 'json',
					success		: function(data){

						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'churnForm', thirdid : thirdid, corpid : corpid}, opts);


	},

	togglePlanForm: function(me){

		if (me.val().contains('entreprise_')){
			$('#nbStaffChoose').show();
		} else {
			$('#nbStaffChoose').hide();
		}

	},

	preparePlan: function(thirdcorpid){

		var formID	= 'prepareAccountPlanForm';

		var opts	= {
			title	: Loc.g('Préparer le périmètre du compte'),
			buttons	: [
				{
					text	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g('Enregistrer'),
					click 	: function(){ $('#'+formID).submit(); }
				}
			],
			callback: function(){

				var formOpts = {
					data		: {action : 'recordPrepareAccountPlanForm', thirdcorpid : thirdcorpid},
					dataType	: 'json',
					success		: function(data){

						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'prepareAccountPlanForm', thirdcorpid : thirdcorpid}, opts);


	},

	changeSelfservice: function(thirdcorpid){

		var formID = "changeSelfserviceForm";

		var opts	= {
			title	: Loc.g('Modifier le self service du compte'),
			buttons	: [
				{
					text 	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g('Enregistrer'),
					click 	: function(){ $('#'+formID).submit(); }
				}
			],
			callback: function(){

				var formOpts = {
					data		: {action : 'recordChangeSelfserviceForm', thirdcorpid : thirdcorpid},
					dataType	: 'json',
					success		: function(data){

						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'changeSelfserviceForm', thirdcorpid : thirdcorpid}, opts);

	},

	changeAccountTrial: function(thirdcorpid){

		var formID	= 'changeAccountTrialForm';

		var opts	= {
			title	: Loc.g('Modifier le trial du compte'),
			buttons	: [
				{
					text 	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g('Enregistrer'),
					click 	: function(){ $('#'+formID).submit(); }
				}
			],
			callback: function(){

				var formOpts = {
					data		: {action : 'recordChangeAccountTrialForm', thirdcorpid : thirdcorpid},
					dataType	: 'json',
					success		: function(data){

						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'changeAccountTrialForm', thirdcorpid : thirdcorpid}, opts);

	},

	toggleTrialDeadlLineSelect: function(me){

		if (me.val() == "Y"){
			$('.trialDeadlineSelect').show();
			MyFacture.customForm();
		} else {
			$('.trialDeadlineSelect').hide();
		}

	},

	autoCorporation: function(field, max, more, selCallback, delCallback, searchType){

		var id = $(field).attr('id');
		searchType	= undefined === searchType ? 'autocomplete' : searchType;

		var options = {
			id					: '#'+id,
			page				: 'sellsyadmin_corporation',
			url					: '&search_type='+searchType ,
			action				: 'autocomplete',
			searchOnFocus		: true,
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			noResultsText		: Loc.g('Aucun compte Sellsy correspondant'),
			tokenValue			: 'id',
			propertyToSearch	: 'name',
			prePopulate			: Persistent.get(id,true,false),
			resultsFormatter 	: function(item) {

				var htmlFormater = '';

				htmlFormater += '<li style="display:table;" class="ac-item wp-10">';
				htmlFormater += 	'<div style="display:table-cell;vertical-align:middle;">';
				htmlFormater += 		'<div class="name ml-1">#' + item.id + ' - ' + item.name + '</div>';
				htmlFormater += 		'<table class="ml-1 fs-2 aleft">';
				htmlFormater += 			'<thead>';
				htmlFormater += 				'<tr>';
				htmlFormater += 					'<th class="info gray-60" style="width:110px">';
				htmlFormater += 						'<span class="info-label label-xsmall">' + Loc.g('Sellsy corp') + '</span>';
				htmlFormater += 					'</th>';
				htmlFormater += 					'<th class="info gray-60">';
				htmlFormater += 						'<span class="info-label label-xsmall">PayCurrency</span>';
				htmlFormater += 					'</th>';
				htmlFormater += 				'</tr>';
				htmlFormater += 			'</thead>';
				htmlFormater += 			'<tbody>';
				htmlFormater += 				'<tr>';
				htmlFormater += 					'<td class="info" style="width:110px">';
				htmlFormater += 						'<span class="info-value">' + item.easybillCorp + '</span>';
				htmlFormater += 					'</td>';
				htmlFormater += 					'<td class="info">';
				htmlFormater += 						'<span class="info-value">' + (item.payCurrencyId == 1 ? '€' : '$') + '</span>';
				htmlFormater += 					'</td>';
				htmlFormater += 				'</tr>';
				htmlFormater += 			'</tbody>';
				htmlFormater += 		'</table>';
				htmlFormater += 	'</div>';
				htmlFormater += '</li>';

				return htmlFormater;

			}
		};

		options.more = (typeof more == "object") ? more : {more : more};

		var selCallback = undefined === selCallback ? '' : selCallback;
		var delCallback = undefined === delCallback ? '' : delCallback;

		if (selCallback !== ''){
			options.onAdd 		= (typeof selCallback === 'function') ? selCallback : function(item){eval(selCallback);};
		}
		if (delCallback !== ''){
			options.onDelete 	= (typeof delCallback === 'function') ? delCallback : function(item){eval(delCallback);};
		}

		TokenInput.create(options);
	},

	editUTM : function(corpid){

		var formID = "utmForm";

		var opts = {
			title	: Loc.g('Edition des UTM'),
			buttons	: [
				{
					text 	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close') }
				}, {
                	text 	: Loc.g('Enregistrer'),
					click 	: function(){ $('#'+formID).submit(); }
                }
            ],

			callback : function(){

				var formOpts = {
					data		: {action : 'utmRecord'},
					dataType	: 'json',
					success		: function(data){

						var formOK = MyForm.processJson(data, formID);

						if(formOK){
							Utils.reload();
						}

					}
				}

				MyForm.prepare(formID, 'sellsyadmin_corporation', formOpts, true);
				Corporation.changeUTMMode($('input[name=utmmode]:checked').val());

			}
		};

		MyWindow.load('sellsyadmin_corporation', {action : 'utmForm', corpid : corpid}, opts);
	},

	changeUTMMode : function(mode){
		if(mode == 'affiliation'){
			$('.affiliation').show();

			$('input#source').val('affiliation').attr('disabled', 'disabled');
			$('input#campaign').attr('disabled', 'disabled');

			if($('#token-input-parrain').length == 0){
				Corporation.autoCorporation(
					$('#parrain'),
					1,
					{},
					function(item){
						var pad			= "00000";
						var campaignID	= "CORP" + pad.substring(0, pad.length - item.id.length) + item.id;
						$('#parrainid').val(item.id);
						$('#campaign').val(campaignID);
					}
				);
			}

		}else{
			$('.affiliation').hide();
			$('input#source').removeAttr('disabled');
			$('input#campaign').removeAttr('disabled');
		}
	},

	switchPricingVersion: function(corporation, version){
		MyFacture.startWait();
		SellsyJS.WebServiceCaller.put('/rest/corporation/'+corporation+'/pricing-version/'+version, {}, {}, function(result) {
			if (result.error) {
				Push.error(result.error.message, Loc.g('Modification version tarifaire'))
				MyFacture.stopWait();
			} else {
				Push.success(Loc.g('Modification réussie'), Loc.g('Modification version tarifaire'))
				Utils.reload();
			}
		});
	}
};

window.AccountantAdmin = {

	customForm : function(){
		$('[e_autoexpert]').each(function(){
			AccountantAdmin.autoExpert($(this), 1, '', $(this).attr('e_autoexpert_sel'), $(this).attr('e_autoexpert_del'));
		});
	},

	selectACExpert : function(item, radio){
		$('input[name=xp_type]#'+radio+'Existing').trigger('click');

		$.ajax({
			url		: '/?_f=sellsyadmin_experts',
			data	: {
				action	: 'loadExpertUsers',
				xpid	: item.xpid,
			},
			type	: 'POST',
			dataType: 'json',
			success : function(data){

				var $select = $('#xpusr_id');
				$('#xpusr_typeExisting').removeAttr('disabled');

				var options = '';

				if(data.xpUsers.length > 0){
					$('#xpusr_typeExisting').attr('checked', 'checked').trigger('change');

					for(var i in data.xpUsers){

						var name = '';
						if(data.xpUsers[i].forename != '' && data.xpUsers[i].forename != 'null' && data.xpUsers[i].forename != null){
							name += data.xpUsers[i].forename;
						}

						if(data.xpUsers[i].name != '' && data.xpUsers[i].name != 'null' && data.xpUsers[i].name != null){
							name += " "+data.xpUsers[i].name;
						}

						if(name == ''){
							name += data.xpUsers[i].email;
						}

						options += '<option value="'+data.xpUsers[i].id+'">'+(name)+'</option>';
					}

					$select.html(options);
					$select.show();
				}else{
					$('#xpusr_typeExisting').attr('disabled', 'disabled');
					$('#xpusr_typeNew').attr('checked', 'checked').trigger('change');
					$select.hide();
				}
			}

		});
	},

	deleteACExpert : function(){
		$('#xpusr_id').empty().hide();
		$('#xpusr_typeExisting').attr('disabled', 'disabled');
		$('#xpusr_typeNew').attr('checked', 'checked').trigger('change');
	},


	autoExpert: function(field, max, more, selCallback, delCallback){

		var id		= $(field).attr('id');

		var options = {
			id					: '#'+id,
			page				: 'sellsyadmin_experts',
			url					: '' ,
			action				: 'expertsAutocomplete',
			searchOnFocus		: true,
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			hintText			: Loc.g('Saisir le nom de l‘expert'),
			noResultsText		: Loc.g('Aucun expert correspondant'),
			tokenValue			: 'id',
			propertyToSearch	: 'name',
			prePopulate			: Persistent.get(id,true,false),
			more 				: {more : more},
			lowerQuery			: false,
		};

		var selCallback = undefined === selCallback ? '' : selCallback;
		var delCallback = undefined === delCallback ? '' : delCallback;

		if (selCallback !== ''){
			options.onAdd = function(item){eval(selCallback);};
		}

		if (delCallback !== ''){
			options.onDelete = function(item){eval(delCallback);};
		}

		TokenInput.create(options);
	},


	addForm : function(acsID){

		var formID	= 'accountantStaffForm';

		var options = {
			title	 : Loc.g('Validation Expert'),
			width	 : 1000,
			callback : function(data){

				var formOpts = {
					data : {
						action	: 'recordExpert',
						acsID	: acsID,
					},
					dataType : 'json',
					success	 : function(data){
						var formOk = MyForm.processJson(data, data.form.formId);

						if(formOk){
							MyWindow.close();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_experts', formOpts, true);

				AccountantAdmin.customForm();


				$('input[name=xp_type]').bind('change', function(){
					if($(this).val() == 'new'){
						$('#xp_type').show();
						$('#xpusr_new').show();
						$('#xp_new').show();
						$('#xpusr_choice').hide();
						$('#xpusr_typeNew').trigger('click');
					}else{
						$('#xp_new').hide();
						$('#xpusr_choice').show();
					}
				});

				$('input[name=xpusr_type]').bind('change', function(){
					if($(this).val() == 'new'){
						$('#xpusr_new').show();
					}else{
						$('#xpusr_new').hide();
					}
				});


			},
			buttons  : [
				{
					text 	: 'Annuler',
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: 'Enregistrer',
					click 	: function(){ $('#'+formID).submit(); }
				}
			]
		};

		MyWindow.load('sellsyadmin_experts',  {action : 'accountantStaffForm', acsID : acsID}, options);
	},


	updateRequestStatus : function(actsID, access){
		MyFacture.post(
				'sellsyadmin_experts',
				{
					action : "updateActsAccess",
					access : access,
					actsID : actsID
				},
				function(data){
					Listing.update('accountantstaffListing');
				},
				'json'
		);
	},

};

window.Experts = {

	prepareFilterForm: function (listingname) {
		var options = {
			success: function (data) {
				Experts.processFilterForm(data, listingname);
			},
			dataType: "json"
		};

		MyForm.prepare(listingname+"FilterForm", "sellsyadmin_experts&action=updateExpertsListing", options);
	},

	processFilterForm: function (data, listingname) {
		Listing.refresh(listingname+"Listing", data, eval('data.'+data.metadatasName));
	}
};

window.AccountantStaffs = {

	prepareFilterForm: function (listingname) {
		var options = {
			success: function (data) {
				Experts.processFilterForm(data, listingname);
			},
			dataType: "json"
		};

		MyForm.prepare(listingname+"FilterForm", "sellsyadmin_experts&action=updateAccountantStaffsListing", options);
	},

	processFilterForm: function (data, listingname) {
		Listing.refresh(listingname+"Listing", data, eval('data.'+data.metadatasName));
	}
};

window.Expert = {
	init : function(expertid){

		Annotation.init();

		MyTabs.initVertical('verticalTab',{
			callback: function (item) {
				MyFacture.post('staff', {action: 'saveTab', linkedtype: 'expert', 'linkedid': expertid, openedTab: item.attr('id')});
			}
		});
	},

	deleteOne : function(xpID){

		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'expert"),
			buttons		: [
				{
					text 	: Loc.g("Annuler"),
					click 	: function(){ $(this).dialog("close"); }
				}, {
					text 	: Loc.g("Valider"),
					click 	: function(){
						MyFacture.post('sellsyadmin_experts', {action : 'deleteOne', xpid : xpID}, function(data){
							if(data.status == 'ok'){
								Utils.relocate('/?_f=sellsyadmin_experts&action=experts');
							}
						}, 'json');
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Valider pour supprimer l'expert."), options);
	},

};


window.SysproductPrice = {

	edit : function(id){

		var formID	= 'sysProductPriceForm';

		var opts	= {
			title	: Loc.g('Modifier le ProductPrice'),
			buttons : [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Enregistrer'),
					click	: function(){ $('#'+formID).submit(); }
				}
			],
			callback : function(){

				var formOpts = {
					data		: {action : 'recordSysProductPriceForm'},
					dataType	: 'json',
					success		: function(data){
						var formOk = MyForm.processJson(data, formID);

						if(formOk){
							MyWindow.close();
							Utils.reload();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_sysproductspricesmap', formOpts, true);
			}
		};

		MyWindow.load('sellsyadmin_sysproductspricesmap', {action : 'sysProductPriceForm',  id:id}, opts);


	}
};


window.SAMetrics = {
	prepareFilterForm: function (listingname) {
		var options = {
			success: function (data) {
				SAMetrics.processFilterForm(data, listingname);
			},
			dataType: "json"
		};

		MyForm.prepare(listingname+"FilterForm", "sellsyadmin_recognition&action=listUpdate", options);
	},

	processFilterForm: function (data, listingname) {
		Listing.refresh(listingname+"Listing", data, eval('data.'+data.metadatasName));
	},


	switchMode : function(listingname){
		var val = $('#'+listingname+'_filter_mode').val();

		$('.filter_customPeriod:not(#'+listingname+'_period_'+val+')').addClass('hidden');
		$('#'+listingname+'_period_'+val).removeClass('hidden');
		MyFacture.customForm('#recognitionsFilterForm');
	},



	getRecognitionForPeriod : function(){

		var formID = 'creditnoteForm';

		// var thirdid		= $('#'+formID+' input[name=thirdid]').val();
		var corpid		= $('#'+formID+' input[name=corpid]').val();
		var startDate	= $('#'+formID+' input[name=dateStart]').val();

		MyFacture.post(
			'sellsyadmin_recognition',
			{
				// action		:'getPCAForThird',
				// thirdid		: thirdid,
				action		:'getPCAForCorp',
				corpid		: corpid,
				startDate	: startDate,
			},
			function(data){
				$('#documentsList').html(data.listing);

				$('#PCAAmount').html(data.pca.formatted_value);
				$('input[name=creditnoteAmount]').val(data.pca.value);

				$('.total').show();

			},
			'json'
		);
	},


	computeRemainingPCAValue : function(parentDocId){

		var startDate	= $('input[name=serviceDateStart]').val();
		var stopDate	= $('input[name=serviceDateStop]').val();

		var data = {
			action		:'computeRemainingPCA',
			startDate	: startDate,
			stopDate	: stopDate,
			docid		: parentDocId,
			doclang		: $('input[name=doclang]').val(),
			thirdid		: $('input[name=thirdid]').val(),
			rateCategory: $('input[name=rateCategory]').val(),
		};

		data = $.extend(true, data, DocFormv2.getNumFormat(true));

		MyFacture.post(
			'sellsyadmin_recognition',
			data,
			function(result){
				DocFormv2.do_deleteRows();
				var rowID = DocFormv2.addRowCallback(result, undefined);

				DocFormv2.updateTotal();

			},
			"html"
		);

	},

	loadRecognitionTab : function(doctype, docid){


		var data = {
			action	:'docTab',
			docid	: docid,
			doctype : doctype,
		};


		MyFacture.post(
			'sellsyadmin_recognition',
			data,
			function(result){

				var xAxis = [];
				var deferred = [], recognized = [], values = [];
				for (var i in result.monthRecognition){
					xAxis.push(result.monthRecognition[i].axis);
					deferred.push(parseFloat(result.monthRecognition[i].deferred, 10));
					recognized.push(parseFloat(result.monthRecognition[i].recognized, 10));
					values.push({
						y : parseFloat(result.monthRecognition[i].value, 10),
						description : result.monthRecognition[i].label,
						name : result.monthRecognition[i].label
					});
				}

				var myChart = new Highcharts.Chart({
					chart: {
						renderTo : 'recognitionChart',
						type: 'column'
					},
					title: {
						text: 'Scheduled recognition'
					},
					xAxis: {
						categories: xAxis
					},
					yAxis: {
						title: {
							text: 'Amount'
						}
					},
					plotOptions: {
						column: {
							stacking: 'normal',
						}
					},
					series: [{
						name: 'Recognized',
						color:'#2fb500',
						data: recognized
					},
					{
						name: 'Deferred',
						color:'#F3AB56',
						data: deferred
					}]
				});
				$('#dataRecognition').empty();
				for(var i in result.dataRecognition){
					var oneData = result.dataRecognition[i];
					var $li = $('<li></li>');
					$li.append('<h4>'+oneData.title+'</h4>');
					$li.append('<div class="value" style="'+(oneData.color != undefined ? 'color:'+oneData.color : '')+'">'+oneData.value+'</div>');
					$li.appendTo("#dataRecognition");
				}

			},
			"json"
		);
	}
};

window.SABilling = {
	createCreditNote : function(corpid){

		var formID = 'creditnoteForm';

		var opts = {
			title	: Loc.g('Avoir annulation abo / option'),
			width	: 600,
			data	: {
				corpid : corpid
			},
			buttons : [
				{
					text 	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g('Créer l‘avoir'),
					click 	: function(){ $('#'+formID).submit(); }
				}
            ],
			callback : function(){

				var formOpt = {
					data : {
						action : 'cancelSubscription',
					},
					dataType : 'json',
					success  : function(data){
						var formOk = MyForm.processJson(data, data.form.formId);
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_recognition', formOpt, true);

			}
		};

		MyWindow.load('sellsyadmin_recognition', {action : 'creditnoteForm', corpid : corpid}, opts);
	},

	upgradeAccount : function(thirdid){

		var formID = "upgradeAccountForm";

		var opts = {
			title	: Loc.g('Devis upgrade abo'),
			width	: 800,
			data	: {
				thirdid : thirdid
			},
			buttons : [
				{
					text 	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g('Créer un devis'),
					click 	: function(){ $('#'+formID).submit(); }
				}
            ],
			callback : function(){

				DocTools.setLangForLayout($("select[name=doclayout]"));

				var formOpt = {
					data : {
						action	: 'recordUpgradeAccountForm',
						thirdid : thirdid
					},
					dataType : 'json',
					success  : function(data){
						var formOk = MyForm.processJson(data, data.form.formId);
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_recognition', formOpt, true);

			}
		};

		MyWindow.load('sellsyadmin_recognition', {action : 'upgradeAccountForm', thirdid : thirdid}, opts);
	}
};



window.Provision = {

	prepareFilterForm: function (listingname) {
		var options = {
			success: function (data) {
				Provision.processFilterForm(data, listingname);
			},
			dataType: "json"
		};

		MyForm.prepare(listingname+"FilterForm", "sellsyadmin_provision&action=listUpdate", options);
	},

	processFilterForm: function (data, listingname) {
		Listing.refresh(listingname+"Listing", data, eval('data.'+data.metadatasName));
	},

	cancelOne: function (id) {

		MyFacture.post(
			'sellsyadmin_corporation',
			{
				action : 'cancelProvision',
				id : id
			},
			function (data){
				var data = JSON.parse(data);

				Push[data.status](data.message);

				Listing.update($('#listingname').length ? $('#listingname').val() : 'thirdprovisionsListing');

			}
		);

	}
};
